import Checkbox from '@mui/material/Checkbox'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import { shouldShowTooltip, truncatedLabel } from '../Helper'
import { useIcons } from './Hook'

interface FilterOptionProps {
  id: string
  label: string
  selected: boolean
  optionProps?: React.HTMLProps<HTMLLIElement>
}

const FilterOption = ({
  id,
  label,
  selected,
  ...optionProps
}: FilterOptionProps) => {
  const { icon, checkedIcon } = useIcons()

  return (
    <li key={id} {...optionProps}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      <Tooltip title={shouldShowTooltip(label) ? label : ''}>
        <Typography>{truncatedLabel(label)}</Typography>
      </Tooltip>
    </li>
  )
}
export default FilterOption
